var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),(_vm.gdprEnabled)?_c('gdpr-config',{scopedSlots:_vm._u([{key:"default",fn:function({ config }){return [(config)?_c('gdpr-cookies',{attrs:{"data":config}}):_vm._e()]}}],null,false,2190615067)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }